<div #container
     class="container bg1 page-keyword {{ showDetail ? 'no-scroll' : '' }}"
     (scroll)="onScroll($event)">

  <app-header showJasoIdx="true"
              [placeholder]="placeholder"
              [curJasoIdx]="curJasoIdx"
              [keyword]="keyword"
              [keyHistory]="HistoryKeySearchWord"
              [secondJaso]="jasoIdxSecond"
              canGoHistory="true"
              (goHistory)="onGoHistory()"
              (search)="onSearch($event)"></app-header>

  <app-left-menu></app-left-menu>

  <section class="keyword-data-list">


    <div class="inner wrap {{ showDetail ? 'detail-open' : '' }}">

      <article class="keyword-item-list">

        <div class="keyword-item-box"
             *ngIf="ll?.getTotalCount() === 0">
          <div class="img-box">
            <img src="assets/img/img_menu_tiger.svg">
          </div>
          <div class="keyword-no-result-box">
            {{ noResultTxt }}
          </div>
          <div *ngIf="!isOptionWordLevelAll()"
               class="keyword-no-result-box left" >
            설정에서 '단어 난이도 표시'를 변경 하고 다시 시도해 보세요.
          </div>
        </div>

        <!-- app-word-list-help *ngIf="isModeServer"></app-word-list-help -->

        <app-word-item *ngFor="let word of ll?.getList(); let idx = index"
                       [word]="word"
                       [select]="showDetail && curDetail.id === word.id"
                       [showLevel]="showLevel"
                       class="keyword-item-box"
                       id="{{ wordSelectId(word) }}" attr.data-index="{{idx}}"
                       (click)="onSelectItem($event, word)"
                       (openWordHelp)="OpenWordHelp()"></app-word-item>
        <div class="reload-icon" *ngIf="!ll?.IsComplete()">
          <!-- button (click)="onClickReload()"><img #reload src="assets/img/loading_icon.gif"></button -->
          <img #reload src="assets/img/loading_icon.gif">
        </div>

      </article>


    </div>



  </section>

  <app-word-detail *ngIf="showDetail" [@wordDetailInOut]
                   class="word-detail keyword-detail"
                   [word_id]="curDetail.id"
                   [height]="detailHeight"
                   (openMap)="onOpenMap($event)"
                   (closeDetail)="onCloseItem($event)"></app-word-detail>

  <app-footer [on]="GetFooterOn()"></app-footer>

  <!-- help popup -->
  <article class="popup popup-help"
           *ngIf="lm.showHelp">
    <app-word-help (closePopup)="CloseWordHelp()"></app-word-help>
  </article>

  <article class="popup popup-help"
           *ngIf="lm.showPitchHelp">
    <app-pitch-help-popup (closePopup)="ClosePitchHelp()"></app-pitch-help-popup>
  </article>


  <app-dialect-map *ngIf="showDialectMap" [@wordDetailInOut]
                   class="dialect-map search-detail type-region"
                   [word]="curWord"
                   [dialects]="curWord.dialects"
                   (closePopup)="CloseDialectMap()"></app-dialect-map>


</div>

<app-common-popups></app-common-popups>
